import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogTitle } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-end-user-licence-agreement',
  templateUrl: './end-user-licence-agreement.component.html',
  styleUrls: ['./end-user-licence-agreement.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [CommonModule, MatDialogTitle],
})
export class EndUserLicenceAgreementComponent implements OnInit {
  isLicence: any;
  ProductType: any;
  currentYear: any;
  defultTheme: boolean = false;
  className: string;
  constructor(
    private router: Router,
    public dialog: MatDialog,
  ) {
    this.isLicence = 'LI';
    this.currentYear = new Date().getFullYear();
    if (localStorage.getItem('theme_type') == 'theme-yellow-light') this.defultTheme = true;
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    if (this.router.url == '/end-user-licence-agreement') {
      setTimeout(() => {
        this.dialog.closeAll();
      }, 50);
    }
  }
}
